module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/cm-gallery/cm-gallery-15-690779a9e901b372104932755dd9f0f4.jpg";